import styles from './Wordmark.module.css'

/**
 * THE MARK — design contract v3 "Colours" §4 `signature-mark`.
 *
 * `Q.` and `Quil.` — the letter set in Jagot followed by a lit full stop. NOT an
 * illustration and nothing drawn: Jagot's Q already performs the font's
 * signature trick unaided, because its tail sits detached at the lower left, so
 * the app's own initial carries the mark naturally. Using the real glyph also
 * keeps the font unmodified, which its licence requires.
 *
 * This replaces v2's "the road", a triangle split by a hard terminator, which
 * was distilled from Frieren and did not survive the reference change.
 *
 * The full stop is the same device at text scale (§3): it belongs to Jagot, so
 * it appears wherever Jagot speaks and nowhere it does not.
 *
 * Reserved to the identity surfaces — icon, splash, sign-in, empty states.
 * Never on chrome, buttons, list items or any high-frequency control.
 */

/** The mark alone: `Q.` Sizes off the inherited font-size. */
export function QMark({ className }: { className?: string }) {
  return (
    <span
      className={`${styles.qmark}${className ? ` ${className}` : ''}`}
      role="img"
      aria-label="Quil"
    >
      <span aria-hidden="true">Q</span>
      <span aria-hidden="true" className={styles.stop}>.</span>
    </span>
  )
}

/** The wordmark: `Quil.` */
export default function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={`${styles.wordmark}${className ? ` ${className}` : ''}`}
      role="img"
      aria-label="Quil"
    >
      <span aria-hidden="true">Quil</span>
      <span aria-hidden="true" className={styles.stop}>.</span>
    </span>
  )
}
